import { injectable } from "inversify";
import UserRepository from "../../repositories/UserRepository";
import UserEntity from "../../entities/UserEntity";
import { Either, isLeft } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import SearchResultEntity from "../../entities/SearchResultEntity";

interface _Props {
    userRepository: UserRepository;
}
@injectable()
export default class GetUserByIdUseCase {
    private userRepository: UserRepository;
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    public call = async (id: string) : Promise<Either<ErrorEntity, UserEntity>> => {
        return this.userRepository.getUserById(id);
    }
}

export const GetUserByIdUseCaseName = "GetUserByIdUseCase";